import React from 'react';
import {
	TextInput,
	BooleanInput,
	required,
	refreshView,
	UPDATE,
	Edit,
	useDataProvider,
	useTranslate,
	useNotify,
} from 'react-admin';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import { Box, Toolbar, Button as MuiButton } from '@material-ui/core';
import IconCancel from '@material-ui/icons/Cancel';
import IconSave from '@material-ui/icons/Save';

const defaultSubscription = {
	submitting: true,
	pristine: true,
	valid: true,
	invalid: true,
};

/*
	Needs to be in a separate component so that the record from wrapping <Edit> is accessible.
*/
const EditBusinessContractParameterForm = ({ record, onSubmit, onCancel, version }) => {
	const translate = useTranslate();
	return (
		<Form
			initialValues={record}
			onSubmit={onSubmit}
			subscription={defaultSubscription}
			key={version}
			keepDirtyOnReinitialize
			render={formProps => (
				<React.Fragment>
					<TextInput
						variant="standard"
						label="resources.businessContractParameters.labels.name"
						source="name"
						validate={required()}
						resettable
						fullWidth
						disabled
					/>
					<TextInput
						variant="standard"
						label="resources.businessContractParameters.labels.value"
						source="value"
						validate={required()}
						resettable
						fullWidth
					/>
					<BooleanInput
						label="resources.businessContractParameters.labels.secure"
						source="secure"
						fullWidth
					/>
					<Toolbar disableGutters>
						<Box display="flex" justifyContent="space-between" width="100%">
							<MuiButton variant="contained" color="primary" disableElevation startIcon={<IconSave />} onClick={formProps.handleSubmit}>
								{translate('coreWalletAdmin.common.saveButton')}
							</MuiButton>
							<MuiButton variant="contained" disableElevation startIcon={<IconCancel />} onClick={onCancel}>
								{translate('coreWalletAdmin.common.cancelButton')}
							</MuiButton>
						</Box>
					</Toolbar>
				</React.Fragment>
			)}
		/>
	);
};

const BusinessContractParameterEdit = ({ businessContractId, businessContractParameterId, ...props }) => {
	const dataProvider = useDataProvider();
	const history = useHistory();
	const dispatch = useDispatch();
	const notify = useNotify();

	const handleSubmit = data => {
		dataProvider(UPDATE, 'businessContractParameters', {
			id: data.businessContractId,
			data,
			method: null
		})
			.then(() => {
				notify('resources.businessContractParameters.notifications.successfullyUpdatedMessage', 'info');
				dispatch(refreshView());
				history.goBack();
			})
			.catch(error => {
				notify(error.message, 'error');
			});
	};

	return (
		<Edit {...props} component="div" title=" " resource="businessContractParameters" id={businessContractParameterId}>
			<EditBusinessContractParameterForm onSubmit={handleSubmit} onCancel={() => history.goBack()} />
		</Edit>
	);
};

export default BusinessContractParameterEdit;
